export default __webpack_public_path__ + "static/media/fb01.f59c1a6b.png";